import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { 
  Radio, Monitor, Settings, LogOut, Phone, FileText
} from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_standby-alert/artifacts/p05naeh5_ChatGPT%20Image%20Apr%206%2C%202026%2C%2009_47_10%20PM.png";

export default function Layout({ children }) {
  const { user, logout } = useAuth();

  const navLinks = [
    { to: '/dispatch', label: 'Dispatch', icon: Phone },
    { to: '/status', label: 'Status Board', icon: Monitor },
    { to: '/reports', label: 'Reports', icon: FileText },
    { to: '/admin', label: 'Admin', icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-zinc-950">
      {/* Top Navigation */}
      <nav className="bg-zinc-900 border-b border-zinc-700 sticky top-0 z-50">
        <div className="max-w-full mx-auto px-4">
          <div className="flex items-center justify-between h-16">
            {/* Logo & Brand */}
            <div className="flex items-center gap-3">
              <img 
                src={LOGO_URL} 
                alt="OSMC" 
                className="w-10 h-10 object-contain"
              />
              <div className="hidden sm:block">
                <h1 className="font-heading text-lg font-bold text-white tracking-tight">
                  OSMC DISPATCH
                </h1>
                <p className="text-zinc-500 text-xs flex items-center gap-1">
                  <Radio className="w-3 h-3" />
                  Medical Standby
                </p>
              </div>
            </div>

            {/* Navigation Links */}
            <div className="flex items-center gap-1">
              {navLinks.map(({ to, label, icon: Icon }) => (
                <NavLink 
                  key={to} 
                  to={to}
                  className={({ isActive }) => 
                    `flex items-center gap-2 px-4 py-2 rounded-sm text-sm font-medium transition-colors ${
                      isActive 
                        ? 'bg-blue-600 text-white' 
                        : 'text-zinc-400 hover:text-white hover:bg-zinc-800'
                    }`
                  }
                  data-testid={`nav-${label.toLowerCase().replace(' ', '-')}`}
                >
                  <Icon className="w-4 h-4" />
                  <span className="hidden sm:inline">{label}</span>
                </NavLink>
              ))}
            </div>

            {/* User & Logout */}
            <div className="flex items-center gap-4">
              <span className="text-zinc-400 text-sm hidden md:block">
                {user?.username || user?.email}
              </span>
              <Button 
                variant="outline" 
                size="sm"
                className="border-zinc-600 text-zinc-300 hover:bg-zinc-800"
                onClick={logout}
                data-testid="logout-button"
              >
                <LogOut className="w-4 h-4 mr-2" />
                <span className="hidden sm:inline">Logout</span>
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        {children}
      </main>
    </div>
  );
}
